<script setup lang="ts">
import TripCardLogo from './TripCardLogo.vue';
import type TripSegment from '@itinerary/trip/TripSegment';
import { type CorporationInfo } from '@itinerary/trip/types';

interface IProps {
    segment: TripSegment;
    mobileView?: boolean;
    logoOnly?: boolean;
}
const { segment, mobileView } = defineProps<IProps>();
const corporationInfos = computed(() =>
    segment.trips
        .map(t => t.corporationInfo)
        .reduce((all, c) => {
            if (!all.some(a => a.title === c.title)) {
                return [...all, c];
            }
            return all;
        }, [] as CorporationInfo[])
);
const title = computed(() =>
    corporationInfos.value.length > 1
        ? 'چند ایرلاین'
        : corporationInfos.value[0].title
);
</script>

<template>
    <div class="logo-view-container" :class="{ 'mobile-view': mobileView }">
        <div class="logos-container">
            <template
                v-for="logo in corporationInfos.slice(0, 2)"
                :key="logo.logoUrl"
            >
                <TripCardLogo
                    :url="logo.logoUrl"
                    :small="corporationInfos.length > 1"
                    :mobile-view
                    :title="logo.title"
                />
            </template>
        </div>
        <div v-if="!logoOnly" class="title-container">
            <mr-typography
                color="var(--cool-gray-600)"
                :size="{
                    mobile: 'x-small',
                    desktop: 'medium',
                }"
                white-space="nowrap"
            >
                {{ title }}
            </mr-typography>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin mobile-view {
    width: 56px !important;
    padding: 0 !important;
    .title-container {
        height: 16px;
    }
}
@include mobile-only() {
    .logo-view-container {
        @include mobile-view();
    }
}
.logo-view-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 96px;
    padding: 16px;
    &.mobile-view {
        @include mobile-view();
    }
}

.logos-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.title-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    .code {
        margin-right: 2px;
    }
}
</style>
